/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'chaos',
    quality: -1+Math.random()*2,
    learning: Math.round(-3.5+Math.random()*7),
	perception: Math.round(-3.5+Math.random()*7),
	mana: Math.round(-3.5+Math.random()*7),
	toughness: Math.round(-3.5+Math.random()*7),
	strength: Math.round(-3.5+Math.random()*7),
	willpower: Math.round(-3.5+Math.random()*7),
	dexterity: Math.round(-3.5+Math.random()*7)
}